import { currencyName } from "../adventure/ActiveAdventure.js";
import type { Item } from "../types/items.js";

/**
 * Gold as a loot drop (I19).
 *
 * Loot tables reference `"gold"` by convention, but no item record ships
 * for it — gold lives in the shared party purse (`PartyStore`), not in a
 * character inventory. Piles still want to LIST it ("Gold ×150"), so this
 * synthetic record stands in wherever a pile needs an `Item`. Pickup
 * paths must divert it to `PartyStore.earnGold` instead of `addItem` —
 * the `inventory:give_item` handler special-cases the id.
 */
export const GOLD_ITEM_ID = "gold";

export function makeGoldItem(): Item {
  return {
    id: GOLD_ITEM_ID,
    // EV-E9: display name follows the adventure's currency setting.
    name: currencyName(),
    category: "misc",
    weightLbs: 0,
    valueCp: 100,
    description: "Currency. Goes straight to the party purse.",
    tags: ["currency"],
    stackable: true,
  };
}
